import './overlay.styles.scss';

const OverLay = () => {
    return (
        <div className='overlay-container'>
            <h1 className='h1-overlay'>A Home or Investment</h1>
            <p className='p-overlay'>We are local everywhere, allowing us to walk alongside our clients at every stage of their journey</p>
        </div>
    )
}

export default OverLay;